import React, { useState, useEffect } from "react";

const ScoreGauge = ({ score, animate = true }) => {
  const [displayScore, setDisplayScore] = useState(animate ? 0 : score);

  useEffect(() => {
    if (!animate) {
      setDisplayScore(score);
      return;
    }
    let current = 0;
    const steps = 60;
    const increment = score / steps;
    const interval = 1500 / steps;
    const timer = setInterval(() => {
      current += increment;
      if (current >= score) {
        current = score;
        clearInterval(timer);
      }
      setDisplayScore(Math.round(current));
    }, interval);
    return () => clearInterval(timer);
  }, [score, animate]);

  const radius = 75;
  const strokeWidth = 13;
  const circumference = 2 * Math.PI * radius;
  const filled = (displayScore / 100) * circumference;
  const color =
    displayScore >= 80 ? "#2E7D32" : displayScore >= 50 ? "#F9A825" : "#C62828";

  return (
    <div
      data-testid="score-gauge"
      style={{ position: "relative", width: 190, height: 190, display: "inline-block" }}
    >
      {/* SVG Circle */}
      <svg
        width="190"
        height="190"
        viewBox="0 0 190 190"
        style={{ display: "block" }}
      >
        {/* Track */}
        <circle
          cx="95"
          cy="95"
          r={radius}
          fill="none"
          stroke="#E5E7EB"
          strokeWidth={strokeWidth}
        />
        {/* Progress */}
        <circle
          cx="95"
          cy="95"
          r={radius}
          fill="none"
          stroke={color}
          strokeWidth={strokeWidth}
          strokeDasharray={`${filled} ${circumference - filled}`}
          strokeLinecap="round"
          transform="rotate(-90 95 95)"
          style={{ transition: "stroke-dasharray 0.05s linear" }}
        />
      </svg>

      {/* Text overlay */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          pointerEvents: "none",
        }}
      >
        <span
          style={{
            fontFamily: "Montserrat, sans-serif",
            fontWeight: 700,
            fontSize: 50,
            color: color,
            lineHeight: 1,
          }}
        >
          {displayScore}
        </span>
        <span
          style={{
            fontFamily: "Inter, sans-serif",
            fontSize: 15,
            color: "#9CA3AF",
            lineHeight: 1.4,
          }}
        >
          / 100
        </span>
      </div>
    </div>
  );
};

export default ScoreGauge;
